import { render, staticRenderFns } from "./IconAcademicCapSolid.vue?vue&type=template&id=50a55af1"
import script from "./IconAcademicCapSolid.vue?vue&type=script&lang=js"
export * from "./IconAcademicCapSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports